"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var enUS = {
  info: {
    culture: 'America',
    language: 'American English',
    languageCultureCode: 'en-US'
  },
  translations: {
    /*
     * NOTE: Direct translations for en-US not needed. This is only for example.
     * Some languages do not have digits. Languages like spanish have inverted
     * question marks and exclamation marks.
     *
     * Always use lowercase for the keys for simple translations. LangCasing for translate can be used.
     * For more unpredictable casing, use case sensitive keys.
     * For example:
     * Title Case: 'What to Expect': 'Ce à quoi vous pouvez vous attendre'
     * One word:
     *    'pick-up': 'ramassage en magasin',
     *     'Pick-Up': 'Ramassage en magasin',
     * There is no way to programmatically guarantee the correct casing in these instances
     *
     * References: If you want to reference a direct translation from the component based translations
     * pass { ref: 'key'}. This good if a phrase is very long, but is used in multiple places. This allows for
     * referencing a single source, but still having the benefit of descriptive keys
     */
    0: '0',
    1: '1',
    2: '2',
    3: '3',
    4: '4',
    5: '5',
    6: '6',
    7: '7',
    8: '8',
    9: '9',
    10: '10',
    '!': '!',
    '?': '?',
    save: 'save',
    extra: 'extra',
    flavor: 'flavor',
    color: 'color',
    center: 'center',
    extras: 'extras'
  },
  translationsByKey: {
    templateChoiceConfig: 'This choice is not available in your current configuration',
    twoConsecutiveNotAllowed: '2 or more consecutive ". / ? - \' " special characters are not allowed.',
    specialNotAllowedExcept: 'Special characters (except for ". / ? -") are not allowed and have been removed',
    sizeNotAvailable: 'Not available in this size',
    tenCharLimit: '10 Character Limit.',
    of: {
      singular: 'of',
      plural: 'of'
    },
    forWidthByHeightIn: 'for {width} in by {height} in',
    Pcp: {
      Configuration: {
        headerText: 'Configure Your Window Treatment',
        colorViewingOnly: 'For color viewing purposes. Mount, cord & tilt options are not shown',
        imagePreviewOnly: 'Image for preview purposes only. Some options will not appear but will be made according to your selections.'
      },
      ErrorBoundary: {
        header: 'A Cat Ruined This Page!',
        info: {
          line1: 'Looks like the page you were looking for got a little messed up',
          line2: 'Please click on the reload button below',
          button: 'Reload Page'
        }
      },
      MeasureSize: {
        tagWarning: 'Please select a Mount Type before entering measurements'
      },
      ProductInfo: {
        infoList: {
          shownIn: 'Shown in',
          colorPlaceholder: 'Select a Color to Preview',
          estShip: {
            ref: 'Estimated Ship Date'
          },
          basedOnSelections: 'Based on your selections'
        }
      },
      ProductInfoPrice: {
        suffix: 'Price Includes Options'
      },
      ProductInstallationCta: {
        toolTipText1: 'One of our Home Depot Design Consultants will show you a range of design options and samples, all in the comfort of your home.',
        toolTipText2: 'A Home Depot Installer will take measurements, order your custom window coverings, and schedule an installation.',
        toolTipText3: 'The Home Depot Installer will then install your new custom window coverings and conduct a thorough clean-up once the job is done.',
        content: {
          header: 'Let Us Do It for You',
          p: 'Get a free in-home design consultation, then schedule an installation.',
          button: 'Request Free Consultation'
        }
      },
      SaveThisProduct: {
        button: 'Save this Product',
        error: 'Oops! Looks like you missed a step'
      },
      SizeOptionGroup: {
        help: 'If you selected **Inside Mount**, enter your window size. For **Outside Mount**, enter the product size you want'
      },
      SubmitErrorModal: {
        title: 'Oops...',
        message: 'We are sorry, but we are unable to add your item to the cart at this time',
        contactUs: 'Please try again or call us at'
      },
      WindowNameTemplate: {
        maxLength: 'Window Name must have 10 characters or less',
        required: 'Window Name is required'
      }
    },
    Pip: {
      HowToGetItDynamic: {
        header: 'How to Get It',
        item1: {
          title: 'Store Pickup',
          description: 'Not Available for this item'
        },
        item2: {
          title: 'Ship to Home',
          description: 'Standard Delivery'
        },
        item3: {
          title: 'Scheduled Delivery',
          description: 'Not Available for this item'
        }
      },
      ProductGallery: {
        samplesCta: {
          header: 'Color Sample Swatches',
          description: 'First 10 swatches are free with next day shipping',
          hoverImageText: 'Hover Image to Zoom',
          productImagesText: 'Product Images',
          button: {
            small: 'Order',
            normal: 'Order Color Samples'
          }
        }
      },
      ProductOptionsView: {
        sampleAlert: 'Sample orders are limited at this time and should be available for this product soon!',
        moreColorsButton: 'View more rows of colors',
        appendAddSamples: ' and Samples'
      },
      ProductOverviewView: {
        exclusiveGuarantee: "Worried about measuring? Get complete peace of mind with Home Depot's exclusive Guaranteed to Fit promise. If your window treatment doesn't fit, we'll send you a new one at no cost. We'll cover shipping too!",
        guarantee: "Worried about measuring? Get complete peace of mind with Home Depot's Guaranteed to Fit promise. If your window treatment doesn't fit, we'll send you a new one at no cost. We'll cover shipping too!",
        sureFitList: {
          limit: 'Limited to 4 blinds per household',
          refund: 'No cash refunds',
          exchange: 'Exchange must be the same product and color',
          charges: "Additional charges may apply if there's a price difference between old and new blinds",
          exchangeDays: 'Exchange must occur within {exchangeDays} days of delivery to your home',
          productReturn: 'Product must be returned to store for replacement'
        }
      },
      ProductPreviewView: {
        samples: {
          heading: 'Free Samples / Free Shipping Included',
          disclaimer: 'If more than 10 samples are ordered, only the first 10 will be shipped.',
          inCart: {
            large: 'free samples in cart',
            normal: 'Free Samples'
          },
          cartButton: {
            large: 'Go to Samples Cart',
            normal: 'Samples Cart'
          }
        }
      },
      ProductSpecifications: {
        infoAndGuidesAcrobat: {
          adobeNeeded: 'You will need Adobe® Acrobat® Reader to view PDF documents. ',
          freeCopyDownload: 'a free copy from the Adobe Web site.',
          freeCopy: 'a free copy from the Adobe Web site.'
        }
      },
      ProductSummary: {
        dropdownLabel: 'Product',
        widthEighths: '{dropdownLabel} Width (eighths)',
        widthWholes: '{dropdownLabel} Width (inches)',
        heightEighths: '{dropdownLabel} Height (eighths)',
        heightWholes: '{dropdownLabel} Height (inches)',
        CTANoShipping: {
          description: "We're unable to ship this item to homes and stores in: AK,GU,HI,PR,VI"
        },
        Highlights: {
          shipping: {
            description: 'Free Shipping'
          },
          productionTime: {
            description: 'Normally made in {days} business days'
          },
          expertHelp: {
            description: 'Call {contactNumber} for Free Expert Help'
          }
        },
        PriceMayVary: {
          message: 'Price and availability may vary by store, and between online and in-store.',
          detailsLink: 'Click here for details.'
        }
      },
      ThdPipView: {
        emailUs: {
          text: 'Email Us',
          size: 90
        },
        mandiHeaderLink: 'You are using our custom window treatments service. Click here to return to the regular website.'
      }
    },
    ErrorBoundary: {
      header: 'Something went wrong.'
    },
    SamplesCart: {
      yourSamplesCart: 'Your Samples Cart',
      outOfItems: 'of',
      banner: {
        freeMessageOrderUpTo: 'Order up to 10 free samples.',
        freeMessageOrderInfo: 'If more than 10 samples are in your cart, they will need to be removed to check out.',
        continueShopping: 'Continue Shopping',
        title: 'Free Shipping',
        thankYouMessage: 'Thank you for your order',
        copyOrderNumber: 'A copy of this order has been sent to your email address.'
      },
      emptyCart: {
        messageTitle: 'Start Adding Some Samples!',
        freeMessage: 'Free ground shipping!',
        messageParagraph: 'First 10 swatches are free, if more than 10 are ordered, only 10 will be shipped.',
        orderSamplesButton: 'Order Samples'
      },
      choiceName: 'Color Name',
      modal: {
        cancelButton: 'Cancel',
        continueButton: 'Continue',
        deleteConfirmation: 'Are you sure you want to remove this item from the cart?',
        errorRemovingItem: 'Error removing item, please try again later.',
        removeButton: 'Remove',
        removeTitle: 'Remove Item',
        "continue": 'Continue',
        sample: 'Sample',
        samples: 'Samples',
        sampleLimitMsg: 'You have exceeded the 10 sample limit.',
        sampleLimitTitle: 'Sample Limit Reached',
        pleaseRemove: 'Please remove',
        pleaseRemoveEnd: 'from your cart to complete your order.'
      },
      removeItem: 'Remove',
      shipToHome: 'Ship To Home',
      shippedIn: 'Shipped in',
      deliveryTimeDay: 'Business Day',
      deliveryTimeDays: 'Business Days',
      deliveryInfo: {
        title: 'Delivery Information',
        firstName: 'First Name',
        lastName: 'Last Name',
        phone: 'Phone',
        email: 'E-Mail',
        address: 'Address',
        addressLine1: 'Enter your address...',
        addressLine2: 'Unit #, Apt #, Suite',
        city: 'City',
        province: 'Province',
        postalCode: 'Postal Code',
        submit: 'Submit',
        select: 'Select'
      },
      errorMessages: {
        firstName: 'First Name is required',
        lastName: 'Last Name is required',
        phone: 'Phone Number is required',
        phone2: 'Invalid Phone Number',
        email: 'Email is required',
        address: 'Address is required',
        city: 'City is required',
        province: 'Province is required',
        postalCode: 'Postal Code is required',
        oops: 'Oops!',
        errorDetails: "We're sorry but the page you requested was not found.",
        errorCode: 'Error Code: 404'
      },
      samplesAlert: {
        exceededMessage: 'You have exceeded the 10 free sample limit.',
        pleaseMessage: 'Please remove',
        samples: 'samples',
        sample: 'sample',
        pleaseMessageEnd: 'to check out.'
      },
      orderConfirmation: {
        sampleItem: 'Sample Item',
        shippingTitleContact: 'Shipping Confirmation'
      }
    }
  }
};
var _default = enUS;
exports["default"] = _default;